import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmExperienceArticlesViewArticleRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceArticlesViewArticleRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { HelpCenterSettingsArticlesViewArticleAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-articles-view-article/src/HelpCenterSettingsArticlesViewArticleAppEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceArticlesViewArticlePageEntryPoint = createPageEntryPoint({
	main,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceArticlesViewArticleRouteEntry: Route = createEntry(
	csmExperienceArticlesViewArticleRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.csm-experience-articles-view-article',
		layout: serviceProjectLayout,
		navigation: {
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmExperienceArticlesViewArticlePageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [...getCustomerServiceL1NavigationResources(), ...getCsmExperiencesResources()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
